import { Box, Text, Stack, Image, Heading } from '@chakra-ui/react';
import { Category } from '../../../api/src/types/types';
import { useAppConfig } from '../../hooks/useAppConfig';
import { getCategoryImage, hasCategoryImage } from '../../config/categoryImages';

export interface CategoryCardProps {
  category: Category;
  onClick: () => void;
}

export const CategoryCard = ({ category, onClick }: CategoryCardProps) => {
  const { ctaColor, ctaTextColor, primaryColor } = useAppConfig();
  const categoryImage = getCategoryImage(category.key);
  const hasImage = hasCategoryImage(category.key);

  return (
    <Stack
      onClick={onClick}
      maxW={{ base: "280px", md: "320px" }}
      w="full"
      cursor="pointer"
      spacing={2}
      transition="all 0.2s"
      _hover={{
        transform: 'translateY(-2px)',
      }}
      _active={{
        transform: 'translateY(0)',
      }}
    >
      {/* Container immagine con overlay - dimensioni ottimizzate */}
      <Box pos="relative" w="full" h={{ base: "160px", md: "200px" }} borderRadius="lg" overflow="hidden">
        <Image
          src={categoryImage}
          alt={category.value}
          w="full"
          h="full"
          objectFit="cover"
          objectPosition="center"
          transition="all 0.3s"
          _hover={{
            transform: 'scale(1.03)',
          }}
          fallback={
            <Box
              w="full"
              h="full"
              bg="gray.100"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Text fontSize="md" color="gray.500" fontWeight="bold">
                IMG
              </Text>
            </Box>
          }
        />
        
        {/* Overlay semi-trasparente */}
        <Box
          position="absolute"
          top="0"
          right="0"
          bottom="0"
          left="0"
          backgroundColor="blackAlpha.300"
          opacity="0"
          transition="opacity 0.3s"
          _hover={{
            opacity: 1,
          }}
        />
      </Box>
      
      {/* Nome categoria */}
      <Heading 
        size={{ base: "sm", md: "md" }}
        color="blue.600"
        textAlign="center"
        noOfLines={1}
        fontSize={{ base: "14px", md: "16px" }}
      >
        {category.value}
      </Heading>
    </Stack>
  );
};
